export const featuresFlags = {
  "9302": {
    uploadCertToSnap: false,
  },
  "843843": {
    uploadCertToSnap: true,
  },
};
